import React from 'react';
import { useEffect, useState, useRef } from 'react';
import LoadingPage from "../components/Loading";
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getProfile, loginWithEmailOtp, requestOtpWithEmail } from '../services/users';
import { insertRegistrationForm } from '../services/registrationForms';
import { validateEmail } from '../utils/util';
const Form = ({ scrollRef, handleSetRightNav }) => {
    const { id: eventId } = useParams();
    const [data, setData] = useState({});
    const [isloading, setisloading] = useState(false);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const ref1 = useRef(null)
    const ref2 = useRef(null)
    const ref3 = useRef(null)
    const ref4 = useRef(null)
    const ref5 = useRef(null)
    const ref6 = useRef(null)
    const [num1, setnum1] = useState('')
    const [num2, setnum2] = useState('')
    const [num3, setnum3] = useState('')
    const [num4, setnum4] = useState('')
    const [num5, setnum5] = useState('')
    const [num6, setnum6] = useState('')
    const [countdown, setcountdown] = useState(0)
    const [isShowOtpPopup, setisShowOtpPopup] = useState(false)

    const handleOtpInput = (num) => (e) => {
        if (num === 1) {
            setnum1(e.target.value); if (e.target.value.length >= 1) ref2.current.focus();
        } else if (num === 2) {
            setnum2(e.target.value); if (e.target.value.length >= 1) ref3.current.focus();
        } else if (num === 3) {
            setnum3(e.target.value); if (e.target.value.length >= 1) ref4.current.focus();
        } else if (num === 4) {
            setnum4(e.target.value); if (e.target.value.length >= 1) ref5.current.focus();
        } else if (num === 5) {
            setnum5(e.target.value); if (e.target.value.length >= 1) ref6.current.focus();
        } else if (num === 6) { setnum6(e.target.value); }
    }
    useEffect(() => {
        let i = setInterval(() => { setcountdown(c => { return (c - 1) <= 0 ? 0 : c - 1 }) }, 1000)
        return () => { clearInterval(i) }
    }, [])

    const token_ = searchParams.get('token') || null

    const [token, setToken] = useState(searchParams.get('token') || null)
    useEffect(() => {
        setToken(token_)
    }, [token_])

    async function fetchDate() {
        if (!token) return
        setisloading(true)
        let result = await getProfile(token);
        if (result?.result) {
            setData(result.result);
        } else {
            setData({});
        }
        setisloading(false)
    }
    useEffect(() => {
        fetchDate()
    }, [token])

    const isMobile = window?.innerWidth < 768
    const handleBack = () => {
        window?.ReactNativeWebView?.postMessage('close')
        navigate(-1)
    }
    const [isShowSuccessfulPage, setisShowSuccessfulPage] = useState(false)
    const handleSubmit = async () => {
        let json = {
            templateId: "68f6f29a7ed071426c12bcb6",
            questions: [{
                user: data
            }],
            email: (data?.email),
        }
        setisloading(true)
        let result = await insertRegistrationForm(json)
        setisloading(false)
        if (result?.errno === 0) {
            setisShowSuccessfulPage(true)
        } else {
            alert(result?.message || '提交失敗，請稍後再試。')
        }
    }

    const [email, setemail] = useState('')
    const onChangeEmail = (e) => {
        setemail(e.target.value)
    }



    const onRequestOtp = async () => {
        if (!validateEmail(email)) {
            alert('電子郵件無效，請重新輸入');
            return
        }
        setisloading(true)

        let result = await requestOtpWithEmail(email)
        if (result.errno) {
            alert(`${result?.message}||Error (70001)`);
            setisloading(false)
            return
        }
        setisShowOtpPopup(true)
        setcountdown(120)
        setisloading(false)
    }
    const cancelOtp = () => {
        setisShowOtpPopup(false)
        setemail('');
        setnum1(''); setnum2(''); setnum3(''); setnum4(''); setnum5(''); setnum6('');
    }


    const handleLoginButton = async () => {
        const otp = `${num1}${num2}${num3}${num4}${num5}${num6}`
        if ((!otp) || otp.length !== 6) { alert('驗證碼無效，請重新輸入'); return; }

        setisloading(true)
        try {
            setisloading(true)
            let res = await loginWithEmailOtp(email, otp)
            if (res.errno) {
                alert(res.message || '驗證碼無效，請重新輸入');
                setisloading(false)
                return
            }

            let token = res?.token?.token
            setToken(token)

            setisShowOtpPopup(false)
            setnum1(''); setnum2(''); setnum3(''); setnum4(''); setnum5(''); setnum6('');
            setisloading(false)


        } catch (e) {
            console.log(e)
            alert(e.message)
        } finally {
            setisloading(false)
        }
    }

    const [isStarted, setisStarted] = useState(false);
    const [isAgreedTandC, setisAgreedTandC] = useState(false);

    const isEnded = true


    if (!isStarted) {
        return (
            <div className='w-full flex-col items-center relative'>
                <div className='grey-bg w-full flex flex-col items-center relative pb-[24px] min-h-[90vh] mt-[64px] flex-1' style={{ backgroundImage: `url(/newlanding/img/home/bg_grain.png)`, zIndex: 2, backgroundSize: 'cover' }}>
                    <img src='https://t-gather.s3.ap-southeast-1.amazonaws.com/home/lucky-draw.png' className="w-full max-w-[600px] mb-[24px]" style={{}} />

                    <div className='p-[16px] w-full' style={{ flex: 1, overflow: 'auto', maxWidth: '800px' }}>
                        【TGather人才節大抽獎】條款及細則
                        <div style={{ whiteSpace: 'pre-wrap' }}>1. 推廣活動概述
                            【TGather人才節大抽獎】(「推廣活動」)由Intuit Insights Company Limited(「Intuit Insights」)主辦。推廣日期為即日起至2025年10月30日下午11時59分止(「推廣期」),並以香港時間及主辦方伺服器接收的時間作準。參加者參與推廣活動即被視作已閲讀、明白並同意遵守所有條款及細則。<br />
                            2. 參加資格<br />
                            符合所有以下條件的參加者(「合資格參加者」),方可參加是次推廣活動:<br />
                            •	參加者須為TGather平台的註冊會員，並已透過官方網站或應用程式完成註冊。<br />
                            •	於推廣期內在指定網頁或應用程式完成登記參與推廣活動及點擊「參加抽獎」，並同意相關聲明。<br />
                            每個電郵地址只限參加推廣活動一次。<br />
                            3. 抽獎資格確認<br />
                            每個合資格參加者將於登記參與推廣活動後的七個工作天內收到主辦方發出的電郵通知,確認已獲得抽獎資格。符合抽獎資格並不保證可獲得獎品。<br />
                            4. 獎品詳情<br />
                            抽獎得獎者合共72位,得獎者(「得獎者」)可獲得以下獎品(「獎品」):<br />
                            •	終極大獎:iPhone 17 Pro 256GB(各價值港幣9,399元)(2名)<br />
                            •	二獎:Apple Watch SE(2nd gen, 40mm)(各價值港幣1,899元)(3名)<br />
                            •	三獎:AirPods(3rd generation)(各價值港幣1,499元)(4名)<br />
                            •	City'super禮品券(各價值港幣500元)(10名)<br />
                            •	Starbucks禮品券(各價值港幣200元)(20名)<br />
                            •	Perplexity Pro plan (12個月) (各價值港幣1,468元)(20名)<br />
                            •	CSL 12個月5G plan(價值$298/1個月)(各價值港幣3,576元)(5名)<br />
                            •	Sony 玻璃揚聲器 LSPX-S3(各價值港幣2,799元)(2名)<br />
                            •	HARIO 胡桃木手沖咖啡壺組套裝(各價值港幣699元)(3名)<br />
                            •	Plaud Note AI商務智慧錄音卡(各價值港幣1,199元)(5名)<br />
                            總獎品價值超過港幣100,000元。<br />
                            5. 抽獎及公佈安排<br />
                            得獎者將於2025年10月31日經由電腦系統隨機抽出。每個電郵地址只可贏取獎品一次。抽獎結果將於2025年11月7日於香港《英文虎報》及《星島日報》及TGather網站內公佈。<br />
                            6. 獎品領取<br />
                            Intuit Insights將於2025年11月7日公佈抽獎結果後發送獎品派發詳情(「獎品換領通知」)至得獎者於登記推廣活動時提供的登記會員電郵。獎品換領通知會列出有關抽獎禮品的兌換安排。得獎者在領取獎品時須出示獎品換領通知及必須現場出示已登入的TGather應用程式會員頁面。<br />
                            如得獎者未能符合條件或中獎者沒有在指定領獎限期三個月內領取獎品,其得獎資格將會被取消而不作另行通知,獎品將被沒收而得獎資格將會被取消並會由候補人士依次補上。<br />
                            7. 宣傳及拍攝<br />
                            得獎者須同意於領獎時由主辦方拍攝領獎照片,並同意TGather有權於任何渠道使用及發放,惟只限於宣傳目的。<br />
                            8. 稅務責任<br />
                            得獎者有責任遵守(自費)任何要求支付與得獎相關的任何稅款、關稅、徵費或類似稅費的法律,Intuit Insights對此不承擔任何責任。<br />
                            9. 第三者權利<br />
                            除合資格參與者及Intuit Insights外,任何人士均無權根據合約(第三者權利)條例執行本條款及細則的任何條文或享有本條款及細則的任何條文的利益。<br />
                            10 . 獎品使用條款<br />
                            獎品不能換取現金、信貸額或任何其他物品。Intuit Insights並不確保及負責獎品之有效性、保養以及相關功能。電郵通知和其他有關獎品換領信於送予得獎者後若有遺失或損毀,恕不補發。所有獎品不得轉讓、退換、兌換現金或任何其他產品。<br />
                            12. 違規處理<br />
                            如因合資格參加者或得獎者因違反任何本條款及細則或任何非法行為導致作出虛假陳述或陳述,或違反適用的法律或法規,或第三方損失,Intuit Insights保留拒絕得獎者兌換獎品的權利,得獎者不得向Intuit Insights提出任何索賠。<br />
                            13. 技術問題及取消資格<br />
                            若本推廣活動因但不限於電腦病毒感染、蠕蟲或木馬程式、伺服器入侵、篡改、未經授權的干預、欺詐、技術故障或任何其他Intuit Insights控制以外的原因,而破壞或影響系統安全性、公平性、誠信及本推廣活動的正常運作,Intuit Insights有權取消任何篡改參加程序的參加者的資格,而毋須發出事先通知或安排。<br />
                            任何因電腦、網路、電話及技術問題或任何其他Intuit Insights控制以外的原因而引致參加者所遞交的資料有遲延、遺失、錯誤、無法辨識及損毀等情況,Intuit Insights毋須負上任何責任,合資格參加者亦不得異議。<br />
                            14. 最終決定權<br />
                            Intuit Insights對本條款及細則擁有絕對解釋權。如有任何爭議,Intuit Insights將擁有最終決定權。<br />
                            15. 私隱政策及個人資料收集<br />
                            參加者只要參加本推廣活動,即表示同意遵守此條款及細則及TGather私隱政策聲明,亦同意接收有關推廣活動的資訊,包括得獎通知。有關TGather私隱政策聲明,請參閱TGather網站。<br />
                            是次抽獎競賽不會額外收集個人資料，只有登記會員方可參加抽獎。我們只會使用登記會員ID編號進行抽獎。本公司會確保所收集的個人資料會根據《個人資料（私隱）條例》（第486章）妥善處理及銷毀。是次競賽只會使用現有會員的ID編號，不會收集額外個人資料，亦不會收集參加者的香港身分證數字。<br />
                            16. 法律管轄<br />
                            此等條款及细則受香港特别行政區法律管轄並按其詮釋,每個合資格參加者遵從香港法院所享有獨有的司法管轄權。如此條款及細則之中文及英文版本存有歧異,以中文版本為準。<br />
                            17. 競賽牌照
                            推廣生意的競賽牌照號碼 : 60712
                        </div>
                    </div>

                    {/*checkbox for agree to terms and conditions*/}
                    <div className='w-full max-w-[800px] px-[16px] flex flex-row items-center mb-[24px]'>
                        <input type='checkbox' className='w-[16px] h-[16px] mr-[8px]' checked={isAgreedTandC} onChange={(e) => { setisAgreedTandC(e.target.checked) }} />
                        <div className='text-[#614E33] text-[14px]'>我已閱讀並同意以上條款及細則。</div>
                    </div>

                    <div className='w-full max-w-[800px] px-[16px] mb-[64px]'>
                        <div onClick={() => {
                            if (!isAgreedTandC) {
                                alert('請先同意條款及細則。')
                                return
                            }
                            setisStarted(true)
                        }} className={`w-full h-[48px] flex cursor-pointer justify-center items-center text-white text-[16px] font-[600] rounded-[99px] ${isAgreedTandC ? 'bg-[#614E33]' : 'bg-[#CCCCCC]'}`}>
                            開始參加抽獎
                        </div>
                    </div>
                </div>
                {/* back button only appear in mobile view, fixed at top left corner,, round, shadow */}
                {isMobile &&
                    <div className='w-[40px] h-[40px] bg-[#00000080] rounded-full shadow-md flex items-center justify-center fixed top-[52px] left-[6px] z-[30] cursor-pointer' onClick={handleBack}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>}

            </div>
        )
    }

    if(isEnded){
        return (
            <div className='w-full flex-col items-center relative'>
                <div className='grey-bg w-full flex flex-col items-center relative p-[24px] min-h-[90vh] mt-[64px]' style={{ backgroundImage: `url(/newlanding/img/home/bg_grain.png)`, zIndex: 2, backgroundSize: 'cover' }}>
                    <div className="relative w-full d-pad-24-m-16 flex flex-col justify-center items-center overflow-hidden max-w-[1300px] border border-[#8c866b] rounded-[50px]">
                        <div className='absolute bottom-0 w-full h-full' style={{ zIndex: 1 }} />
                        <div className="flex flex-col w-full items-center gap-[16px]" style={{ zIndex: 2 }}>
                            <div className="font-[500] text-[32px] text-[#6E604C] text-center">
                                2025香港國際人才節 <br /> TGather 人才節大抽獎
                            </div>

                            <div className='text-[32px] font-bold  text-[black] my-[24px]'>抽獎活動已結束</div>
                        </div>
                    </div>
                </div>
                {isloading && <LoadingPage />}
                {/* back button only appear in mobile view, fixed at top left corner,, round, shadow */}
                {isMobile &&
                    <div className='w-[40px] h-[40px] bg-[#00000080] rounded-full shadow-md flex items-center justify-center fixed top-[52px] left-[6px] z-[30] cursor-pointer' onClick={handleBack}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>}

            </div>
        )
    }

    if (!data || !data?._id) {
        return (
            <div className='w-full flex-col items-center relative'>
                <div className='grey-bg w-full flex flex-col items-center relative p-[24px] min-h-[90vh] mt-[64px]' style={{ backgroundImage: `url(/newlanding/img/home/bg_grain.png)`, zIndex: 2, backgroundSize: 'cover' }}>
                    <div className="relative w-full d-pad-24-m-16 flex flex-col justify-center items-center overflow-hidden max-w-[1300px] border border-[#8c866b] rounded-[50px]">
                        <div className='absolute bottom-0 w-full h-full' style={{ zIndex: 1 }} />
                        <div className="flex flex-col w-full items-center gap-[16px]" style={{ zIndex: 2 }}>
                            <div className="font-[500] text-[28px] text-[#6E604C] text-center">
                                2025香港國際人才節 <br /> TGather 人才節大抽獎
                            </div>

                            <div className='text-[32px] font-bold  text-[black] my-[24px]'>你尚未登入</div>

                            <div className="w-full flex flex-col items-start gap-[8px] max-w-[800px] pt-[8px]">
                                <div className="text-[#6E604C] font-[400] text-[16px] flex flex-row items-end">*電郵 <div className="text-[12px]">(Email)</div></div>
                                <div className="flex flex-row w-full gap-[12px]">
                                    <div className="flex-1 pb-[8px] h-full" style={{ borderBottom: '1px solid #00000033' }}>
                                        <input onChange={onChangeEmail} value={email || ''} className="w-full bg-[transparent] border-none" placeholder="請填寫" />
                                    </div>
                                </div>
                                <div onClick={onRequestOtp} className="w-full h-[39px] flex cursor-pointer justify-center items-center text-white text-[14px] font-[500] rounded-[99px]" style={{ background: 'linear-gradient(180deg, #8C866B 0%, rgba(143, 137, 109, 0.96) 14%, rgba(153, 146, 116, 0.84) 32%, rgba(169, 160, 127, 0.8) 53%, rgba(153, 146, 116, 0.4) 100%)', border: '1px solid #8F896DF5' }}>
                                    發送驗證碼
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {isloading && <LoadingPage />}

                {isShowOtpPopup && <div className="fixed top-0 bottom-0 left-0 right-0 bg-[#00000070] flex items-center justify-center p-[16px] z-[3]">
                    <div className="flex flex-col w-full max-w-[800px] bg-[#fff] rounded-[24px] d-px64-m-px-16 py-[32px] justify-center items-center" style={{ boxSizing: 'border-box' }}>
                        <div className="text-[#6E604C] text-[32px] font-[700]">驗證</div>
                        <div className="flex flex-row text-[#938474] font-[400] text-[16px] w-full text-left mt-[64px]">
                            驗證碼已發送至
                            <div className="ml-[16px] font-[700] d-flex-m-hidden">{email || ''}</div>
                        </div>
                        <div className="font-[700] d-hidden-m-flex text-[#938474] text-[12px] text-left w-full">{email || ''}</div>

                        <div className='w-full flex flex-row justify-start mt-5 ' style={{ gap: 8, boxSizing: 'border-box' }}>
                            <div className='flex-[1]' style={{ height: undefined, aspectRatio: 1, }}>
                                <input value={num1} onChange={handleOtpInput(1)} ref={ref1} className='w-full h-full text-[32px] text-center' maxLength={1} style={{ borderColor: '#8D876C', borderWidth: .5, borderRadius: 8, boxSizing: 'border-box' }} />
                            </div>
                            <div className='flex-[1]' style={{ height: undefined, aspectRatio: 1, }}>
                                <input value={num2} onChange={handleOtpInput(2)} ref={ref2} className='w-full h-full text-[32px] text-center' maxLength={1} style={{ borderColor: '#8D876C', borderWidth: .5, borderRadius: 8, boxSizing: 'border-box' }} />
                            </div>
                            <div className='flex-[1]' style={{ height: undefined, aspectRatio: 1, }}>
                                <input value={num3} onChange={handleOtpInput(3)} ref={ref3} className='w-full h-full text-[32px] text-center' maxLength={1} style={{ borderColor: '#8D876C', borderWidth: .5, borderRadius: 8, boxSizing: 'border-box' }} />
                            </div>
                            <div className='flex-[1]' style={{ height: undefined, aspectRatio: 1, }}>
                                <input value={num4} onChange={handleOtpInput(4)} ref={ref4} className='w-full h-full text-[32px] text-center' maxLength={1} style={{ borderColor: '#8D876C', borderWidth: .5, borderRadius: 8, boxSizing: 'border-box' }} />
                            </div>
                            <div className='flex-[1]' style={{ height: undefined, aspectRatio: 1, }}>
                                <input value={num5} onChange={handleOtpInput(5)} ref={ref5} className='w-full h-full text-[32px] text-center' maxLength={1} style={{ borderColor: '#8D876C', borderWidth: .5, borderRadius: 8, boxSizing: 'border-box' }} />
                            </div>
                            <div className='flex-[1]' style={{ height: undefined, aspectRatio: 1, }}>
                                <input value={num6} onChange={handleOtpInput(6)} ref={ref6} className='w-full h-full text-[32px] text-center' maxLength={1} style={{ borderColor: '#8D876C', borderWidth: .5, borderRadius: 8, boxSizing: 'border-box' }} />
                            </div>
                        </div>

                        {/* <div className='flex flex-row w-full items-center justify-between mt-5'>
                        {countdown > 0
                            ? <div className='text-[#949494] text-[14px]'>{countdown}秒後重新發送</div>
                            : <div onClick={onRequestOtp} className='underline text-[14px] text-[#6E604C] cursor-pointer'>重新發送</div>
                        }
                    </div> */}

                        <div onClick={handleLoginButton} className="d-flex-m-hidden h-[72px] bg-[#0F737E] w-full rounded-[99px] text-white text-[24px] font-[500] text-center flex items-center justify-center cursor-pointer mt-[64px]">
                            確認
                        </div>
                        <div onClick={cancelOtp} className="d-flex-m-hidden h-[72px] bg-[#fff] w-full rounded-[99px] text-[#0F737E] text-[24px] font-[500] text-center flex items-center justify-center cursor-pointer mt-[4px]">
                            取消
                        </div>

                    </div>
                </div>}

                {/* back button only appear in mobile view, fixed at top left corner,, round, shadow */}
                {isMobile &&
                    <div className='w-[40px] h-[40px] bg-[#00000080] rounded-full shadow-md flex items-center justify-center fixed top-[52px] left-[6px] z-[30] cursor-pointer' onClick={handleBack}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>}

            </div>
        );
    }

    // if(data?.data?.membership!=='星級會員'&&data?.data?.membership!=='尊享會員'){
    //     return (
    //         <div className='w-full flex-col items-center relative'>
    //             <div className='grey-bg w-full flex flex-col items-center relative p-[24px] min-h-[90vh] mt-[64px]' style={{ backgroundImage: `url(/newlanding/img/home/bg_grain.png)`, zIndex: 2, backgroundSize: 'cover' }}>
    //                 <div className="relative w-full d-pad-24-m-16 flex flex-col justify-center items-center overflow-hidden max-w-[1300px] border border-[#8c866b] rounded-[50px]">
    //                     <div className='absolute bottom-0 w-full h-full' style={{ zIndex: 1 }} />
    //                     <div className="flex flex-col w-full items-center gap-[16px]" style={{ zIndex: 2 }}>
    //                         <div className="font-[500] text-[32px] text-[#6E604C] text-center">
    //                             2025香港國際人才節 <br /> TGather 人才節大抽獎
    //                         </div>

    //                         <div className='text-[32px] font-bold  text-[black] my-[24px]'>抽獎僅限星級會員及尊享會員<br/>請升級您的會員資格</div>
    //                     </div>
    //                 </div>
    //             </div>
    //             {isloading && <LoadingPage />}
    //             {/* back button only appear in mobile view, fixed at top left corner,, round, shadow */}
    //             {isMobile &&
    //                 <div className='w-[40px] h-[40px] bg-[#00000080] rounded-full shadow-md flex items-center justify-center fixed top-[52px] left-[6px] z-[30] cursor-pointer' onClick={handleBack}>
    //                     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                         <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    //                     </svg>
    //                 </div>}

    //         </div>
    //     );
    // }   

    
    if (isShowSuccessfulPage) {
        return (
            <div className='w-full flex-col items-center relative'>
                <div className='grey-bg w-full flex flex-col items-center relative p-[24px] min-h-[90vh] mt-[64px]' style={{ backgroundImage: `url(/newlanding/img/home/bg_grain.png)`, zIndex: 2, backgroundSize: 'cover' }}>
                    <div className="relative w-full d-pad-24-m-16 flex flex-col justify-center items-center overflow-hidden max-w-[1300px] border border-[#8c866b] rounded-[50px]">
                        <div className='absolute bottom-0 w-full h-full' style={{ zIndex: 1 }} />
                        <div className="flex flex-col w-full items-center gap-[16px]" style={{ zIndex: 2 }}>
                            <div className="font-[500] text-[32px] text-[#6E604C] text-center">
                                2025香港國際人才節 <br /> TGather 人才節大抽獎
                            </div>

                            <div className='text-[32px] font-bold  text-[#6E604C] my-[24px]'>報名成功！</div>

                            <div className='text-[24px] my-[8px] text-[#6E604C] text-center'>感謝你以<b>{data?.email}</b><br />會員身份參加抽獎</div>

                            <div className='text-[16px] my-[8px] text-[#6E604C] text-center'>推廣生意的競賽牌照號碼 : 60712</div>

                            {/*download app button*/}
                            {/*google button*/}
                            <a href='https://play.google.com/store/apps/details?id=com.aquila.tgather' target='_blank' className='w-full max-w-[300px] mt-[24px]'>
                                <img src='https://t-gather.s3.ap-southeast-1.amazonaws.com/upload/68c7658ff79f0cc7cbfa00bb/1758079366663.png' className='w-full h-auto'/>
                            </a>
                            {/*apple button*/}
                            <a href='https://apps.apple.com/us/app/t-gather/id6738165815' target='_blank' className='w-full max-w-[300px] mt-[6px]'>
                                <img src='https://t-gather.s3.ap-southeast-1.amazonaws.com/upload/68c7658ff79f0cc7cbfa00bb/1758079347053.png' className='w-full h-auto'/>
                            </a>
                        </div>
                    </div>
                </div>

                {isloading && <LoadingPage />}

                {/* back button only appear in mobile view, fixed at top left corner,, round, shadow */}
                {isMobile &&
                    <div className='w-[40px] h-[40px] bg-[#00000080] rounded-full shadow-md flex items-center justify-center fixed top-[52px] left-[6px] z-[30] cursor-pointer' onClick={handleBack}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>}
            </div>
        );
    }

    return (
        <div className='w-full flex-col items-center relative'>

            <div className='w-full flex-col items-center relative mt-[64px]'>
                <div className='grey-bg w-full flex flex-col items-center relative p-[24px] min-h-[90vh]' style={{ backgroundImage: `url(/newlanding/img/home/bg_grain.png)`, zIndex: 2, backgroundSize: 'cover' }}>
                    <div className="relative w-full d-pad-24-m-16 flex flex-col justify-center items-center overflow-hidden max-w-[1300px] border border-[#8c866b] rounded-[50px]">
                        <div className='absolute bottom-0 w-full h-full' style={{ zIndex: 1 }} />
                        <div className="flex flex-col w-full items-center gap-[16px]" style={{ zIndex: 2 }}>
                            <div className="font-[500] text-[32px] text-[#6E604C] text-center">
                                2025香港國際人才節 <br /> TGather 人才節大抽獎
                            </div>



                            <div className='text-[32px] font-bold  text-[black] my-[24px]'>你已登入</div>

                            <div className='text-[24px] my-[8px] text-[#6E604C] text-center'>以<b>{data?.email || data?.mobile || "-"}</b><br />會員身份參加抽獎</div>

                            <div onClick={handleSubmit} className="d-flex-m-hidden h-[72px] bg-[#0F737E] w-full rounded-[99px] text-white text-[24px] font-[500] text-center flex items-center justify-center cursor-pointer mt-[64px]">
                                參加抽獎
                            </div>
                            <div className='text-[16px] my-[8px] text-[#6E604C] text-center'>推廣生意的競賽牌照號碼 : 60712</div>


                        </div>
                    </div>
                </div>
            </div>


            {isloading && <LoadingPage />}

            {/* back button only appear in mobile view, fixed at top left corner,, round, shadow */}
            {isMobile &&
                <div className='w-[40px] h-[40px] bg-[#00000080] rounded-full shadow-md flex items-center justify-center fixed top-[52px] left-[6px] z-[30] cursor-pointer' onClick={handleBack}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>}
        </div>
    );
};

export default Form;